import { FC, Fragment } from "react";
import { Box } from "@mui/material";
import { BillingExplorerWidgetSetupContentCosts } from "../BillingExplorerWidgetSetupContentCosts";
import { useAppSelector } from "@/store/hooks";
import { billingExplorerSetupPropertyByKeySelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerSetupPropertyByKeySelector";
import { billingExplorerSetupHasAggregationSelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerSetupHasAggregationSelector";
import { billingExplorerWidgetSetupNoChartViewDataSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupNoChartViewDataSelector";
import { BillingExplorerWidgetAgGrid } from "@/components/pages/dashboard/components/widgets/billing-explorer-widget/components/chart/ag-table/BillingExplorerWidgetAgGrid";
import { billingExplorerWidgetSetupTotalDataCountSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupTotalDataCountSelector";
import { billingExplorerWidgetSetupTotalCostDateDetailsSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupTotalCostDateDetailsSelector";
import { billingExplorerWidgetSetupPrevCostDateDetailsSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupPrevCostDateDetailsSelector";
import { billingExplorerWidgetSetupTableTrendSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupTableTrendSelector";
import { billingExplorerWidgetSetupForecastedCostsSumSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupForecastedCostsSumSelector";
import { billingExplorerWidgetSetupLoadingSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupLoadingSelector";

export const BillingExplorerWidgetSetupTableView: FC = () => {
  const gridData = useAppSelector(
    billingExplorerWidgetSetupNoChartViewDataSelector,
  );
  const totalItemsCount = useAppSelector(
    billingExplorerWidgetSetupTotalDataCountSelector,
  );
  const totalCostDates = useAppSelector(
    billingExplorerWidgetSetupTotalCostDateDetailsSelector,
  );
  const totalTrend = useAppSelector(
    billingExplorerWidgetSetupTableTrendSelector,
  );
  const prevCostDates = useAppSelector(
    billingExplorerWidgetSetupPrevCostDateDetailsSelector,
  );
  const forecastedCost = useAppSelector(
    billingExplorerWidgetSetupForecastedCostsSumSelector,
  );

  const grouping = useAppSelector(
    billingExplorerSetupPropertyByKeySelector("grouping"),
  );

  const forecastOption = useAppSelector(
    billingExplorerSetupPropertyByKeySelector("forecastOption"),
  );

  const visualization = useAppSelector((state) =>
    billingExplorerSetupPropertyByKeySelector("visualization")(state),
  );

  const hasAggregations = useAppSelector(
    billingExplorerSetupHasAggregationSelector,
  );

  const loading = useAppSelector(billingExplorerWidgetSetupLoadingSelector);

  return (
    <Fragment>
      {hasAggregations && (
        <Box p={2}>
          <BillingExplorerWidgetSetupContentCosts />
        </Box>
      )}
      <BillingExplorerWidgetAgGrid
        data={gridData}
        loading={loading}
        grouping={grouping}
        totalTrend={totalTrend}
        prevCostDates={prevCostDates}
        visualization={visualization}
        forecastOption={forecastOption}
        forecastedCost={forecastedCost}
        totalCostDates={totalCostDates}
        totalItemsCount={totalItemsCount}
      />
    </Fragment>
  );
};
